import { VehiculoEntity } from "./vehiculo_entity";
import { ViviendaEntity } from "./vivienda_entity";
import { VidaEntity } from "./vida_entity";
import { AsistenciaMedicaEntity } from "./asistencia_medica_entity";
import { ProductosGeneralesEntity } from "./productos_generales_entity";
import { VehiculoCorporativosEntity } from "./vehiculo_entity";

export class SegurosContratadosEntity {
    constructor(
        public SegurosVehiculo?: VehiculoEntity[],
        public SegurosVivienda?: ViviendaEntity[],
        public Vida?: VidaEntity[],
        public AsistenciaMedica?: AsistenciaMedicaEntity[],
        public ProductosGenerales?: ProductosGeneralesEntity[],
        public VehiculosCorporativos?: VehiculoCorporativosEntity[]
        

    ) { }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/datosGenerales/entities/seguros_contratados_entity.ts